class PreDefinedNote {
  constructor(title) {
    this.title = title;
  }
}
export default {
  inject: ['load'],
  data() {
    return {
      confimType: '',
      preDefinedNoteId: null,
      searchTitle: '',
      disabelConfirm: false,
    };
  },
  methods: {
    enableAddEditFunction: function (type, id) {
      if (type == 1) {
        this.confimType = 'add';
        for (let i = 0; i < this.allPreDefinedNotes.length; i++) {
          if (this.allPreDefinedNotes[i].id == 0) {
            return;
          }
        }
        this.allPreDefinedNotes.push({ title: '', isEdit: true, id: 0 });
      } else if (type == 2) {
        this.confimType = 'edit';
        let temp = this.allPreDefinedNotes;
        for (var i = 0; i < temp.length; i++) {
          if (temp[i].id == id) {
            temp[i].isEdit = true;
          }
        }
        this.allPreDefinedNotes = [];
        this.allPreDefinedNotes = temp;
        this.getPreDefinedNoteFunction(id);
      }
    },
    cancelAddEditFunction: function (id) {
      this.preDefinedNote = new PreDefinedNote('');
      for (var i = 0; i < this.allPreDefinedNotes.length; i++) {
        if (this.allPreDefinedNotes[i].id == id) {
          if (id == 0) {
            this.allPreDefinedNotes.splice(i, 1);
          }
          this.allPreDefinedNotes[i].isEdit = false;
        }
      }
    },
    showConfirmDialogFunction: function () {
      if (this.confimType == 'add') {
        this.addPreDefinedNoteFunction();
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.title = 'ویرایش توضیح';
        this.$refs.confirm.text = 'از ویرایش توضیح اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.title = 'حذف توضیح';
        this.$refs.confirm.text = 'از حذف توضیح اطمینان دارید؟';
        this.$refs.confirm.showConfirmDialog = true;
      }
      requestAnimationFrame(() => {
        if (this.$refs.yes) {
          this.$refs.yes.$el.focus();
        }
      });
    },
    confirmDialogConfirmFunction: function () {
      if (this.confimType == 'add') {
        this.disabelConfirm = true;
        this.addPreDefinedNoteFunction();
      } else if (this.confimType == 'edit') {
        this.disabelConfirm = true;
        this.editPreDefinedNoteFunction();
      } else if (this.confimType == 'delete') {
        this.disabelConfirm = true;
        this.deletePreDefinedNoteFunction();
      }
    },
    confirmDialogCancelFunction: function () {
      if (this.confimType == 'add') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'edit') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      } else if (this.confimType == 'delete') {
        this.$refs.confirm.showConfirmDialog = false;
        this.disabelConfirm = false;
      }
    },
    //delete
    showDeleteConfirmFunction: function (id) {
      this.preDefinedNoteId = id;
      this.confimType = 'delete';
      this.showConfirmDialogFunction();
    },
  },
};
